export default __webpack_public_path__ + "static/media/group77.75dee104.svg";